import React, { useMemo } from 'react';
import { Container, Modal, ModalBody, ModalFooter } from 'react-bootstrap';
import BankInstructions from '../../../../assets/bank-instructions.svg';
import Button from '../../../../components/Button';
import Checkbox from '../../../../components/Checkbox/Checkbox';
import CheckboxGroup from '../../../../components/Checkbox/CheckboxGroup';
import ModalHeader from '../../../../components/ModalHeader';
import AddNewBankAccountForm from './AddNewBankAccountForm';

export type customAddNewBankModalProps = React.PropsWithoutRef<{
  showModal: boolean;
  handleClose: () => void;
  handleAddNewBank: (bank: any) => void;
  banks: any[];
}>;

const AddNewBankModal = ({
  showModal = false,
  handleClose,
  handleAddNewBank,
  banks,
}: customAddNewBankModalProps) => {
  const [value, setValue] = React.useState<string[]>([]);
  const [formData, setFormData] = React.useState<any>({});

  const handleChange = (event: any, values: string[]) => {
    setValue(values);
  };

  const handleSaveFromData = (formData: any) => {
    setFormData(formData);
  };

  const isNewBankValid = useMemo(() => {
    const {
      routingNumber,
      accountNickname,
      accountNumber,
      reEnterAccountNumber,
      type,
      institutionName,
    } = formData;

    if (
      !type ||
      !routingNumber ||
      !accountNickname ||
      !institutionName ||
      !accountNumber ||
      !reEnterAccountNumber ||
      accountNumber !== reEnterAccountNumber
    ) {
      return false;
    }

    return true;
  }, [formData]);

  const isFormValid = () => {
    if (isNewBankValid && value[0]) {
      return true;
    }

    return false;
  };

  const handleSubmitForm = () => {
    //must be change if there is more than 2 types of bank profiles
    const type = formData.type === '1' ? 'Savings' : 'Checking';

    handleAddNewBank({
      id: (banks.length + 1).toString(),
      iban: formData.routingNumber.toString(),
      name: formData.institutionName,
      routingNumber: formData.routingNumber,
      accountNumber: formData.accountNumber,
      type: type,
      accountNickname: formData.accountNickname,
    });
    setValue([]);
    handleClose();
  };

  return (
    <Modal show={showModal} onHide={handleClose} size={'lg'}>
      <ModalHeader closeButton>
        <div className="ps-lg-5 text-sm-20-lg-32">
          <h4>Add New Account</h4>
        </div>
      </ModalHeader>
      <ModalBody className="pt-9  text-dark-gray fw-light">
        <section>
          <Container className="p-0 d-flex justify-content-center">
            <img
              className="w-100"
              src={BankInstructions}
              alt="bank-instructions"
            />
          </Container>
        </section>
        <section className="mt-12">
          <AddNewBankAccountForm handleOnSubmit={handleSaveFromData} />
        </section>
        <section className="d-flex flex-row mt-12">
          <CheckboxGroup
            name={'no-labels'}
            value={value}
            onChange={handleChange}
          >
            <Checkbox value={'1'} id={'2'} variant="sm" />
          </CheckboxGroup>
          <span className="ps-8 text-caption text-ligther-grey fw-light lh-xs">
            I authorized that my benefit payments be deposited directly into the
            account named above until I instruct otherwise. If an incorrect
            amount is deposited into my account, I authorize the appropriate
            adjustment to my account.
          </span>
        </section>
      </ModalBody>
      <ModalFooter>
        <Button
          variant="primary-outline"
          onClick={handleClose}
          className="mt-7 mt-lg-0"
        >
          Cancel
        </Button>
        <Button
          variant="primary"
          onClick={handleSubmitForm}
          disabled={!isFormValid()}
        >
          Save Bank
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default AddNewBankModal;
